import React, { forwardRef } from 'react';
import { NotificationBadge as EdsNotificationBadge } from '@ellucian/react-design-system/core/es/Badge';
const NotificationBadge = (props, ref) => (React.createElement(EdsNotificationBadge, Object.assign({ ref: ref }, props)));
const NotificationBadgeFRC = forwardRef(NotificationBadge);
NotificationBadgeFRC.displayName = 'NotificationBadgeFRC';
export default NotificationBadgeFRC;
